import { t as translateDate } from './translate-date.js';
import { U as Url } from './url.min.js';
import './index2.js';

/*
 * Clock Software
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isRegnumBanskoHotelAndSpa = thn.data.accountUserId === 1042751;

  engine.boot = function boot() {

    const container = document.querySelector('#page_loading');

    if (container && !thn.clocksoftPageUpdater) {
      thn.clocksoftPageUpdater = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(container, thn.clocksoftPageUpdater, {
        childList: false,
        subtree: false,
        attributes: true,
        attributeFilter: ['class'],
      });

      thn.shutdown(function () {
        thn.stopObserveDom(container, thn.clocksoftPageUpdater);
        delete thn.clocksoftPageUpdater;
      });
    }

    const indexContainer = document.querySelector('#app');
    if (indexContainer) {
      const refreshPage = thn.debounce(thn.pageCheck, 400);

      thn.observeDom(indexContainer, refreshPage, {
        childList: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(indexContainer, refreshPage);
      });
    }

    const langContainer = document.querySelector('.languages');
    if (langContainer) {
      const langRefresh = thn.debounce(thn.languageCheck, 400);

      thn.observeDom(indexContainer, langRefresh, {
        childList: true,
      });

      thn.shutdown(() => {
        langRefresh.cancel();
        thn.stopObserveDom(indexContainer, langRefresh);
      });
    }

  };

  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      let lang;

      if (isRegnumBanskoHotelAndSpa) {
        lang = document.querySelector('div.languages > span.active')?.textContent;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      lang = window.location.pathname.match(new RegExp('^/[^/]+/[^/]+/wbe/(\\w{2})(/|$)', 'i')) || window.location.pathname.match(ctx.urlRe);
      lang = lang && lang.length && lang[1];
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }
      lang = thn.parseUrlParameter('language');
      lang = lang && lang.slice(0, 2);
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }
      reject('no_language');
    });
  };

  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    const url = new Url();
    const specificRate = !thn.empty(url.query['product_search[room_type_id][]']) || $('.showing_only_selected_rooms:visible').length;
    // For PID 1027431 there is a 'fi' lang so it causes error on thn.translate_date. For this case we force 'en' lang.
    const langToTranslateDate = (thn.data.propertyId === 1027431) ? 'en' : thn.data.language;

    if (!specificRate) {

      if (url.query['product_search[arrival]']) {
        if (url.query['product_search[arrival]'].match(/\d{4}-\d{2}-\d{2}/)) {
          widgetData.dateBegin = url.query['product_search[arrival]'].replace(/-/g, '/');
        } else {
          widgetData.dateBegin = translateDate(url.query['product_search[arrival]'].replace(/\+/g, ' '), langToTranslateDate);
        }
      } else if (url.query['wbe_product[arrival]']) {
        if (url.query['wbe_product[arrival]'].match(/\d{4}-\d{2}-\d{2}/)) {
          widgetData.dateBegin = url.query['wbe_product[arrival]'].replace(/-/g, '/');
        } else {
          widgetData.dateBegin = translateDate(url.query['wbe_product[arrival]'].replace(/\+/g, ' '), langToTranslateDate);
        }
      }
      if (url.query['product_search[departure]']) {
        if (url.query['product_search[departure]'].match(/\d{4}-\d{2}-\d{2}/)) {
          widgetData.dateEnd = url.query['product_search[departure]'].replace(/-/g, '/');
        } else {
          widgetData.dateEnd = translateDate(url.query['product_search[departure]'].replace(/\+/g, ' '), langToTranslateDate);
        }
      } else if (url.query['wbe_product[departure]']) {
        if (url.query['wbe_product[departure]'].match(/\d{4}-\d{2}-\d{2}/)) {
          widgetData.dateEnd = url.query['wbe_product[departure]'].replace(/-/g, '/');
        } else {
          widgetData.dateEnd = translateDate(url.query['wbe_product[departure]'].replace(/\+/g, ' '), langToTranslateDate);
        }
      } else if (widgetData.dateBegin) {
        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, parseInt(url.query['product_search[nights]'], 10) || 1));
      }

      // 2018-10-11: Fallback to the blue header of the enginge, where dates are printed.
      // The reason behind this fallback is that some clients saw a different BE URL, which
      // didn't have the dates specified. All the conditions we have are checked against the URL,
      // so for that case, dates were not valid and an error was thrown when trying to get the nights
      // (thn.days_between).
      if (!widgetData.dateBegin || !widgetData.dateEnd) {
        let headerDates = $('.h2.text-center');
        headerDates = headerDates && headerDates.text().split(',');
        headerDates = headerDates && headerDates.length && headerDates[0].split('-');
        if (headerDates.length && thn.data.language) {
          widgetData.dateBegin = translateDate(headerDates[0], thn.data.language);
        }
        if (headerDates.length > 1 && thn.data.language) {
          widgetData.dateEnd = translateDate(headerDates[1], thn.data.language);
        }
      }
      const queryAdults = url.query['wbe_product[adult_count]'] || url.query['wbe_product%5Badult_count%5D'] || url.query['product_search[adult_count]'] || url.query['product_search%5Badult_count%5D'];
      widgetData.adults = parseInt(queryAdults || '2', 10);
      const queryChildren = url.query['wbe_product[children_count]'] || url.query['wbe_product%5Bchildren_count%5D"'] || url.query['product_search[children_count]'] || url.query['product_search%5Bchildren_count%5D'];
      widgetData.children = parseInt(queryChildren || '0', 10);
      widgetData.guests = widgetData.adults + widgetData.children;
      widgetData.rooms = 1;

      const $prices = $('.room-type > td:nth-child(2) h4, td:nth-child(2) b').map(function (idx, el) {
        if ($(el).parents('[id^=not_available_rates]').length) {
          return null;
        }
        return $(el).clone().children().remove()
          .end();
      });
      const prices = $prices.map(function (idx, el) {
        return thn.parseNumber($(el).text());
      }).toArray();

      if (prices.length) {
        if (widgetData.dateBegin && widgetData.dateEnd) {
          widgetData.price = Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
          widgetData.currency = thn.getCurrencyCode($prices.eq(0).text().match(/[^\d\s,.]+/)[0]);
          widgetData.set = true;
        } else { thn.logger.debug('Dates couldn\'t be obtained. Price unset.'); }
      } else if ($('.alert.alert-danger:visible').length) {
        widgetData.noRooms = true;
      }

    } // specific rate

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // No info at all, just the cost in a tangent image:
    // "<img src="https://pubads.g.doubleclick.net/activity;xsp=647171;qty=1;cost=295.12;ord=000002126?" width=1 height=1 border=0/>"
    // if the image is present get the price
    const price = thn.parseNumber((((document.querySelector('img[src*=cost]') || {}).src || '').match(/cost=[^;]+/) || [])[0]);

    // use if it is greater than the estimated one
    if (price && price > ctx.estimatedData.price) {
      widgetData.price = price;
    }

    // Don't use jQuery here, not all implementations of this BE has it
    widgetData.bookingId = ((document.querySelector('h3.text-success > span.label-success') || {}).textContent || '').trim();

    // Aurora Village (p1027431) uses the snippet thn.widgets.booking.init() and they give us the bookingId with a '#' added on the start
    if (thn.data.propertyId === 1027431 && widgetData.bookingId) {
      widgetData.bookingId = `#${widgetData.bookingId}`;
    }

    // pick rest of the info from the estimated data

    return widgetData;
  };

  return engine;

}

export { factory };
